/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-02-07 17:42:21
 * @LastEditors: pj
 * @LastEditTime: 2023-02-13 15:48:40
 */
import request from '@/utils/request'

// 获取账户资料
export function user_info (params) {
    return request({
        method: 'get',
        url: '/platform/pc/user/info',
        params
    })
}

// 账号安全中心
export function user_safety (params) {
    return request({
        method: 'get',
        url: '/platform/pc/user/safety',
        params
    })
}
//实名认证

export function bind_idcard (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/bind/idcard',
        data
    })
}

//短信校验  下一步
export function reset_checkd (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/reset/check',
        data
    })
}


//获取密保问题配置
export function safety_questions (data) {
    return request({
        method: 'get',
        url: '/platform/pc/safety/questions',
        data
    })
}
// 保存 密保信息
export function safety_save (data) {
    return request({
        method: 'post',
        url: '/platform/pc/safety/save',
        data
    })
}
export function safety_cancel (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/cancel',
        data
    })
}

// 绑定 手机

export function bind_mobile (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/bind/mobile',
        data
    })
}


// 我的游戏
export function user_game (params) {
    return request({
        method: 'get',
        url: '/platform/pc/user/game',
        params
    })
}

// 获取用户设置的密保问题
export function question_list (params) {
    return request({
        method: 'get',
        url: '/platform/pc/user/question/list',
        params
    })
}

// 重置信息密保问题校验
export function question_check (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/question/check',
        data
    })
}
// 重置 修改密码
export function reset_password (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/reset/password',
        data
    })
}

// 重置账户信息初始化数据
export function safety_reset (params) {
    return request({
        method: 'get',
        url: '/platform/pc/safety/reset/init',
        params
    })
}

// 校验用户实名信息

export function check_idcard (data) {
    return request({
        method: 'post',
        url: '/platform/pc/check/idcard',
        data
    })
}